<template>
  <div class="rightarea-outter">
    <div>
        <border style="width: 500px;height: 290px;">
            <template v-slot:title>
                <customTitle text="组织机构统计" />
            </template>
            <template v-slot:tabledata>
                <count />
            </template>
        </border>
    </div>
    <div>
        <border style="width: 500px;height: 290px;">
            <template v-slot:title>
                <customTitle text="课程学习人数占比统计" />
            </template>
            <template v-slot:tabledata>
                <pie3D />
            </template>
        </border>
    </div>
  </div>
</template>

<script>
import border from '@/components/main/components/border.vue'
import customTitle from '@/components/main/components/title.vue'
import count from './right-components/count.vue'
import pie3D from './right-components/pie3D.vue'
export default {
    components: {
        border,
        customTitle,
        count,
        pie3D
    }
}
</script>

<style scoped>
.rightarea-outter {
    width: 500px;
    height: 600px;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
}
</style>